// extracted by mini-css-extract-plugin
module.exports = {"lottieContainer":"DotLottieReactLoader_lottieContainer__DsYqa","lottie":"DotLottieReactLoader_lottie__LQOwX"};